import { Col, Empty, Row, Spin } from 'antd';
import React from 'react';

type Props<T> = {
  loading?: boolean;
  dataSource?: T[];
  rowKey: keyof T | ((row: T) => string);
  renderItem: (item: T) => React.ReactNode;
  locale?: { emptyText?: React.ReactNode };
  /** 卡片栅格：默认一排最多 3 个 */
  columns?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
};

function resolveKey<T>(row: T, rowKey: Props<T>['rowKey']) {
  if (typeof rowKey === 'function') return rowKey(row);
  return String(row[rowKey]);
}

/** 卡片视图：等宽栅格对齐 */
function CardListView<T>({
  loading,
  dataSource,
  rowKey,
  renderItem,
  locale,
  columns = { xs: 1, sm: 2, lg: 3 },
}: Props<T>) {
  if (loading && !dataSource?.length) {
    return (
      <div style={{ textAlign: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }
  if (!dataSource?.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={locale?.emptyText || '暂无数据'}
        style={{ padding: 48 }}
      />
    );
  }

  const span = (n?: number) => (n && n > 0 ? Math.floor(24 / n) : 24);

  return (
    <Spin spinning={!!loading}>
      <Row gutter={[16, 16]} style={{ marginTop: 4 }}>
        {dataSource.map((item) => (
          <Col
            key={resolveKey(item, rowKey)}
            xs={span(columns.xs)}
            sm={span(columns.sm)}
            md={span(columns.md ?? columns.sm)}
            lg={span(columns.lg)}
            xl={span(columns.xl ?? columns.lg)}
            style={{ display: 'flex' }}
          >
            <div style={{ width: '100%', display: 'flex' }}>{renderItem(item)}</div>
          </Col>
        ))}
      </Row>
    </Spin>
  );
}

export default CardListView;
